import React from "react";
import {
  Box,
  Text,
  Flex,
  Avatar,
  useColorModeValue,
  Spinner,
} from "@chakra-ui/react";
import ReactMarkdown from "react-markdown";

interface StreamingMessageProps {
  message: string;
  isTyping?: boolean;
}

const StreamingMessage: React.FC<StreamingMessageProps> = ({
  message,
  isTyping = false,
}) => {
  const bgColor = useColorModeValue("gray.50", "gray.700");
  const textColor = useColorModeValue("gray.800", "white");
  const avatarBg = useColorModeValue("gray.500", "gray.300");

  return (
    <Flex mb={4} justify="flex-start" align="flex-start" gap={3}>
      <Avatar
        size="sm"
        bg={avatarBg}
        color="white"
        name="AI Assistant"
        src="/ai-avatar.png"
      />

      <Box
        maxW="70%"
        bg={bgColor}
        p={3}
        borderRadius="lg"
        borderBottomLeftRadius="sm"
        position="relative"
      >
        {message ? (
          <Box color={textColor} fontSize="sm">
            {message && typeof message === "string" ? (
              <Text color={textColor} fontSize="sm" whiteSpace="pre-wrap">
                <ReactMarkdown>{message}</ReactMarkdown>
                {isTyping && (
                  <Box as="span" ml={1}>
                    <Text as="span" animation="1.4s infinite">
                      |
                    </Text>
                  </Box>
                )}
              </Text>
            ) : (
              <Text whiteSpace="pre-wrap">
                {message || "No message content"}
                {isTyping && (
                  <Box as="span" ml={1}>
                    <Text as="span" animation="1.4s infinite">
                      |
                    </Text>
                  </Box>
                )}
              </Text>
            )}
          </Box>
        ) : (
          <Flex align="center" gap={2}>
            <Spinner size="sm" color="blue.500" />
            <Text color={textColor} fontSize="sm">
              AI is typing...
            </Text>
          </Flex>
        )}
      </Box>
    </Flex>
  );
};

export default StreamingMessage;
